import { Brand } from '@hbo/ui-servicing-react-components';
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import i18next from 'i18next';

const baseUrls = {
  [Brand.NatWest]: process.env.REACT_APP_API_BASE_URL_NATWEST,
  [Brand.RoyalBankOfScotland]: process.env.REACT_APP_API_BASE_URL_RBS
};

const client = axios.create({
  baseURL: baseUrls[window.obm?.brand || Brand.NatWest]
});

export const setRequestInterceptors = (callback: (config: AxiosRequestConfig) => void) => {
  client.interceptors.request.use(function (config) {
    callback(config);
    return config;
  });
};

const getAccessToken = () => sessionStorage.getItem('access_token');

client.interceptors.request.use(function (config: any) {
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${getAccessToken()}`
  };
  return config;
});

client.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error) => Promise.reject(new AxiosError(i18next.t('generic.serverError'), error))
);

export default client;
